import React from 'react';
import $ from 'jquery';
import Language from '../services/Language.js';
import utils from '../services/utils.js';
import AppModalWidget from './AppModalWidget.js';

let inst;

class RequisiteNotFoundModalWidget extends React.Component {
    constructor(props) {
        super(props);
        if (!inst) {
            this.url = '';
            this.sendedData = {};
            this.modalObject = null;
            this.requisiteNotFoundModalModal = null;
            this.settings = {};
            inst = this;
        }
        return inst;
    }

    callback() { }

    showRequisiteNotFoundModal(url, sendedData, callback, userSettings) {

        if ($('.jsP2PPage').length) {
            $('.jsP2PPage')[0].dispatchEvent(new Event("closeMoneyOutForm"));
        }

        let that = this;
        this.url = url;
        this.sendedData = sendedData;
        if (typeof callback === 'function') {
            this.callback = callback;
        }

        const modalSettings = {};

        this.modalObject = $("<div />", {
            "class": "systemModal jsRequisiteNotFoundModal"
        });

        this.modalObject.html(
            `<form id="requisiteNotFoundModalModal" action="#" class="systemModal__form">
                    <div class="systemModal__controls">
                        `+ Language.getLabel('L_MERCHANT_DISABLED_ACCEPTANCE_ORDERS') + `
                    </div>
                    <div class="systemModal__actions">
                        <button class="button button--blue__light modal-approve">` + Language.getLabel('L_UPDATE_LIST_OF_MERCHANTS') + `</button>
                        <button class="button button--orange modal-close jsCloseModal">` + Language.getLabel('L_CLOSE') + `</button>
                    </div>
                </div>
            </form>`
        );

        this.requisiteNotFoundModalModal = this.modalObject.find("#requisiteNotFoundModalModal");

        const handleSubmit = (e) => {
            e && e.preventDefault();
            if ($('.jsMerchantDataTable').length) {
                $('.jsMerchantDataTable')[0].dispatchEvent(new Event("updatedTraderTable"));
            }

            that.close(() => {});
        };

        this.requisiteNotFoundModalModal.submit(handleSubmit);

        modalSettings.el = this.modalObject;
        modalSettings.destroyClose = true;

        modalSettings.afterShow = () => {
            this.afterShowHandler();
        };

        AppModalWidget.show(modalSettings);
    }

    afterShowHandler() { }

    recentAnimation() { }

    close(cb) {
        if (this.modalObject) {
            AppModalWidget.close(cb);
        }
    }
}

export default new RequisiteNotFoundModalWidget();